// extracted by mini-css-extract-plugin
export default {"container":"XvIUHC","text":"v8BtXb","buttonContainer":"uweDcm"};